import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { loadStripe } from '@stripe/stripe-js';
import { Elements, CardElement, useStripe, useElements } from '@stripe/react-stripe-js';
import { Helmet } from 'react-helmet-async';
import './styles/Payment.css';

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY);

const CheckoutForm = () => {
  const stripe = useStripe();
  const elements = useElements();
  const navigate = useNavigate();
  const location = useLocation();
  
  const { productId, productName, amount } = location.state || {};
  
  const [errorMessage, setErrorMessage] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    setErrorMessage(null);

    if (!stripe || !elements) {
      setErrorMessage("Stripe n'est pas encore chargé.");
      setLoading(false);
      return;
    }

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/create-payment-intent`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ amount, productId }),
        credentials: "include"
      });

      const { clientSecret } = await response.json();

      if (!clientSecret) {
        throw new Error('Échec de la création de l\'intention de paiement.');
      }

      const result = await stripe.confirmCardPayment(clientSecret, {
        payment_method: {
          card: elements.getElement(CardElement),
        },
      });

      if (result.error) {
        throw new Error(result.error.message);
      }

      navigate('/confirmation', { state: { productName, amount } });

    } catch (error) {
      setErrorMessage(error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Helmet>
        <title>Paiement sécurisé - {productName} | WinlyDeal</title>
        <meta name="description" content={`Finalisez votre contribution pour ${productName} en toute sécurité avec notre système de paiement sécurisé Stripe.`} />
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      <form className="payment-form" onSubmit={handleSubmit}>
        <h1 className="payment-title">Paiement sécurisé pour {productName}</h1>
        <p className="payment-amount">Montant à payer : {amount} €</p>

        <div className="payment-card">
          <CardElement options={{ hidePostalCode: true }} />
        </div>

        {errorMessage && <p className="payment-error">{errorMessage}</p>}

        <button className="payment-button" type="submit" disabled={!stripe || loading}>
          {loading ? 'Paiement en cours...' : 'Payer maintenant'}
        </button>
      </form>
    </>
  );
};

const Payment = () => {
  return (
    <Elements stripe={stripePromise}>
      <div className="payment-container">
        <CheckoutForm />
      </div>
    </Elements>
  );
};

export default Payment;
